<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="応募者管理＿選考フェーズ・ステータス設定"
      />
      <section>
        <h3 class="boss-joboffer-title boss-setting">
          選考フェーズの設定
        </h3>
        <p class="boss-text">
          ここで設定した選考フェーズで応募者管理ができ、応募者一覧や応募者詳細画面で参照できます。<br>※選考フェーズを編集すると、既に選考中の応募者にも反映されますので、ご注意ください
        </p>
        <div class="boss-phase-preview-container">
          <div class="boss-phase-preview">
            <p class="boss-phase-preview-text">
              選考フェーズのプレビュー
            </p>
            <ul
              :class="[selectedPhases && selectedPhases.length > 5 ? 'boss-phase-preview-list-wrap' : '']"
              class="clearfix boss-phase-preview-list"
            >
              <li
                v-for="(phase, i) in selectedPhases"
                :key="i"
                class="boss-phase-preview-item"
              >
                <span class="boss-phase-preview-item-text">{{ phase.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="boss-selection-container">
          <div class="boss-select-container boss-left boss-select-balloon">
            <div class="boss-select-title">
              <span class="boss-select-text">設定されている選考フェーズ</span>
            </div>
            <div class="boss-select-wrap">
              <ul class="boss-select-list-phase pega-clear-padding">
                <div class="pega-drag-area min-height-0 padding-bottom-0">
                  <li
                    v-if="entryPhase"
                    class="boss-select-item boss-no-move pega-no-move"
                  >
                    <span
                      class="boss-select-item-text"
                      data-test="phase-entry"
                    >{{ entryPhase.name }}</span>
                  </li>
                </div>
                <div
                  v-if="isDraggingPhase"
                  class="boss-select-item pega-drop-area margin-bottom-1 border-none-side"
                  data-test="drop-area-phase"
                >
                  <p>↓ この範囲に要素をドラッグしてください</p>
                </div>
                <draggable
                  v-model="selectedPhases"
                  :move="move"
                  class="pega-drag-area padding-top-0 min-height-phase-setting"
                  group="unselectedPhases"
                  data-test="draggable-selected-phase"
                  @change="changePhase"
                  @start="changeDraggingPhase"
                  @end="changeDraggingPhase"
                >
                  <template v-for="(phase, i) in selectedPhases">
                    <li
                      v-if="!phase.isEntryPhase"
                      :key="i"
                      :class="{ 'boss-no-move': phase.isRequired }"
                      :data-test="'selected-phase-' + i"
                      class="boss-select-item boss-any"
                      style="display:block"
                    >
                      <span
                        v-if="!phase.isEditing"
                        :data-test="'selected-phase-name-' + i"
                        class="boss-select-item-text"
                      >{{ phase.name }}</span>
                      <input
                        v-if="phase.isEditing"
                        :ref="`selected-phase-${i}`"
                        v-model="phase.editName"
                        :class="{ 'is-invalid-input': phase.isInvalidName }"
                        :data-test="'selected-phase-name-edit-' + i"
                        class="pega-select-input"
                        max-length="5"
                        type="text"
                        @keypress="finishEdit($event,phase)"
                        @keyup="checkInvalidName(phase)"
                        @blur="finishEdit($event,phase)"
                      >
                      <span
                        v-if="!phase.isRequired && !phase.isEditing"
                        :data-test="'selected-phase-any-' + i"
                        class="boss-any-text"
                      >任意</span>
                      <span
                        v-if="phase.isDeletable && !phase.isEditing"
                        :data-test="'selected-phase-edit-' + i"
                        class="boss-icon-pencil pega-selected"
                        @click="goEdit(phase,`selected-phase-${i}`)"
                      />
                      <validation-label
                        v-if="phase.isInvalidName"
                        :data-test="'selected-phase-error-' + i"
                        :label="phase.error"
                      />
                    </li>
                  </template>
                </draggable>
                <div
                  v-if="isDraggingPhase"
                  class="boss-select-item pega-drop-area border-none-side"
                  data-test="drop-area-phase"
                >
                  <p>↑ この範囲に要素をドラッグしてください</p>
                </div>
              </ul>
            </div>
          </div>
          <div class="boss-center-container">
            <div class="boss-arrow" />
          </div>
          <div class="boss-select-container boss-right">
            <div class="boss-select-title">
              <span class="boss-select-text">設定したい項目名を<br>右枠から左枠にドラッグしてください。</span>
            </div>
            <div class="boss-select-setting">
              <div class="boss-select-input-container">
                <input
                  v-model="addPhaseName"
                  :class="{ 'is-invalid-input': isOverPhaseNameLength }"
                  class="boss-select-input"
                  type="text"
                  placeholder="選考フェーズ名の新規作成"
                  data-test="new-phase"
                  @keypress="addPhase"
                >
                <validation-label
                  v-if="isOverPhaseNameLength"
                  data-test="is-over-phase-name-length"
                  label="選考フェーズ名は5文字以内で入力してください"
                />
                <p class="boss-select-input-text">
                  最大全角5文字まで入力可能です。<br>入力してEnterキーを押下すると、下に項目名が追加されます。
                </p>
              </div>
              <div class="boss-select-wrap pega-clear-padding display-phase-setting-right-height">
                <ul class="boss-select-list border-none">
                  <div
                    v-if="isDraggingPhase && !isDraggingPhaseRequired"
                    class="boss-select-item pega-drop-area border-none-side"
                    data-test="drop-area-phase-unselected"
                  >
                    <p>↓ この範囲に要素をドラッグしてください</p>
                  </div>
                  <draggable
                    id="unselected"
                    v-model="unselectedPhases"
                    class="pega-drag-area min-height-phase-no-setting"
                    group="unselectedPhases"
                    data-test="draggable-unselected-phase"
                    @start="changeDraggingPhase"
                    @end="changeDraggingPhase"
                  >
                    <li
                      v-for="(phase, i) in unselectedPhases"
                      :key="i"
                      :data-test="'unselected-phase-' + i"
                      class="boss-select-item boss-any"
                      style="display:block"
                    >
                      <span
                        v-if="!phase.isEditing"
                        :data-test="'unselected-phase-name-' + i"
                        class="boss-select-item-text"
                      >{{ phase.name }}</span>
                      <input
                        v-if="phase.isEditing"
                        :ref="`unselected-phase-${i}`"
                        v-model="phase.editName"
                        :class="{ 'is-invalid-input': phase.isInvalidName }"
                        class="pega-select-input"
                        max-length="5"
                        type="text"
                        :data-test="'unselected-phase-name-edit-' + i"
                        @keypress="finishEdit($event,phase)"
                        @keyup="checkInvalidName(phase)"
                        @blur="finishEdit($event,phase)"
                      >
                      <span
                        v-if="!phase.isEditing"
                        :data-test="'unselected-phase-any-' + i"
                        class="boss-any-text"
                      >任意</span>
                      <span
                        v-if="phase.isDeletable && !phase.isEditing"
                        :data-test="'unselected-phase-reset-' + i"
                        class="boss-icon-trash"
                        @click="removePhase(phase)"
                      />
                      <span
                        v-if="phase.isDeletable && !phase.isEditing"
                        :data-test="'unselected-phase-edit-' + i"
                        class="boss-icon-pencil"
                        @click="goEdit(phase,`unselected-phase-${i}`)"
                      />
                      <validation-label
                        v-if="phase.isInvalidName"
                        :data-test="'unselected-phase-error-' + i"
                        :label="phase.error"
                      />
                    </li>
                  </draggable>
                  <div
                    v-if="isDraggingPhase && !isDraggingPhaseRequired"
                    class="boss-select-item pega-drop-area border-none-side"
                    data-test="drop-area-phase-unselected"
                  >
                    <p>↑ この範囲に要素をドラッグしてください</p>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="boss-button-container">
          <button
            class="boss-button-default pega-button"
            data-test="phase-update"
            :disabled="hasEditingPhases"
            @click="registerPhases"
          >
            選考フェーズを更新する
          </button>
        </div>
      </section>
      <section>
        <h3 class="boss-joboffer-title boss-setting">
          選考ステータスの設定
        </h3>
        <p class="boss-text margin-bottom-1">
          ここで設定した選考ステータスで応募者管理ができ、応募者一覧や応募者詳細画面で参照できます。<br>※選考ステータスを編集すると、既に選考中の応募者にも反映されますので、ご注意ください
        </p>
        <div class="boss-selection-container boss-status">
          <div class="boss-select-container boss-left">
            <div class="boss-select-title">
              <span class="boss-select-text">設定されている選考ステータス</span>
            </div>
            <div class="boss-select-wrap">
              <ul class="boss-select-list-phase pega-clear-padding">
                <div
                  v-if="isDraggingStatus"
                  class="boss-select-item pega-drop-area border-none-side"
                  data-test="drop-area-status"
                >
                  <p>↓ この範囲に要素をドラッグしてください</p>
                </div>
                <draggable
                  v-model="selectedStatuses"
                  group="status"
                  :class="['pega-drag-area padding-bottom-0', { 'min-height-status-setting': isDraggingStatus, 'min-height-auto': !isDraggingStatus }]"
                  data-test="draggable-selected-status"
                  @change="changeStatus"
                  @start="changeDraggingStatus"
                  @end="changeDraggingStatus"
                >
                  <template v-for="(status, i) in selectedStatuses">
                    <li
                      v-if="!status.isRequired"
                      :key="i"
                      :data-test="'selected-status-' + i"
                      class="boss-select-item boss-any"
                      style="display:block"
                    >
                      <span
                        v-if="!status.isEditing"
                        :data-test="'selected-status-name-' + i"
                        class="boss-select-item-text"
                      >{{ status.name }}</span>
                      <input
                        v-if="status.isEditing"
                        :ref="`selected-status-${i}`"
                        v-model="status.editName"
                        :class="{ 'is-invalid-input': status.isInvalidName }"
                        class="pega-select-input"
                        max-length="5"
                        type="text"
                        :data-test="'selected-status-name-edit-' + i"
                        @keypress="finishEdit($event,status)"
                        @keyup="checkInvalidName(status)"
                        @blur="finishEdit($event,status)"
                      >
                      <span
                        v-if="!status.isEditing"
                        :data-test="'selected-status-any-' + i"
                        class="boss-any-text"
                      >任意</span>
                      <span
                        v-if="status.isDeletable && !status.isEditing"
                        :data-test="'selected-status-edit-' + i"
                        class="boss-icon-pencil pega-selected"
                        @click="goEdit(status,`selected-status-${i}`)"
                      />
                      <validation-label
                        v-if="status.isInvalidName"
                        :data-test="'selected-status-error-' + i"
                        :label="status.error"
                      />
                    </li>
                  </template>
                </draggable>
                <div
                  v-if="isDraggingStatus"
                  class="boss-select-item pega-drop-area border-none-side margin-top-1"
                  data-test="drop-area-status"
                >
                  <p>↑ この範囲に要素をドラッグしてください</p>
                </div>
                <div class="pega-drag-area min-height-0 padding-top-0">
                  <li
                    v-for="(status, i) in requiredStatuses"
                    :key="i"
                    :data-test="'selected-required-status-' + i"
                    class="boss-select-item boss-no-move pega-no-move"
                  >
                    <span
                      :data-test="'selected-required-status-name-' + i"
                      class="boss-select-item-text"
                    >{{ status.name }}</span>
                  </li>
                </div>
              </ul>
            </div>
          </div>
          <div class="boss-center-container">
            <div class="boss-arrow" />
          </div>
          <div class="boss-select-container boss-right">
            <div class="boss-select-title">
              <span class="boss-select-text">設定したい項目名を<br>右枠から左枠にドラッグしてください。</span>
            </div>
            <div class="boss-select-setting">
              <div class="boss-select-input-container">
                <input
                  v-model="addStatusName"
                  :class="{ 'is-invalid-input': isOverStatusNameLength }"
                  class="boss-select-input"
                  type="text"
                  placeholder="選考ステータスの新規作成"
                  data-test="new-status"
                  @keypress="addStatus"
                >
                <validation-label
                  v-if="isOverStatusNameLength"
                  data-test="is-over-status-name-length"
                  label="選考ステータス名は5文字以内で入力してください"
                />
                <p class="boss-select-input-text">
                  最大全角5文字まで入力可能です。<br>入力してEnterキーを押下すると、下に項目名が追加されます。
                </p>
              </div>
              <div class="boss-select-wrap pega-clear-padding display-phase-setting-right-height">
                <ul class="boss-select-list border-none">
                  <div
                    v-if="isDraggingStatus"
                    class="boss-select-item pega-drop-area border-none-side"
                    data-test="drop-area-status"
                  >
                    <p>↓ この範囲に要素をドラッグしてください</p>
                  </div>
                  <draggable
                    id="unselected"
                    v-model="unselectedStatuses"
                    class="pega-drag-area min-height-status-no-setting"
                    group="status"
                    data-test="draggable-unselected-status"
                    @start="changeDraggingStatus"
                    @end="changeDraggingStatus"
                  >
                    <li
                      v-for="(status, i) in unselectedStatuses"
                      :key="i"
                      :data-test="'unselected-status-' + i"
                      class="boss-select-item boss-any"
                      style="display:block"
                    >
                      <span
                        v-if="!status.isEditing"
                        :data-test="'unselected-status-name-' + i"
                        class="boss-select-item-text"
                      >{{ status.name }}</span>
                      <input
                        v-if="status.isEditing"
                        :ref="`unselected-status-${i}`"
                        v-model="status.editName"
                        :class="{ 'is-invalid-input': status.isInvalidName }"
                        class="pega-select-input"
                        max-length="5"
                        type="text"
                        :data-test="'unselected-status-name-edit-' + i"
                        @keypress="finishEdit($event,status)"
                        @keyup="checkInvalidName(status)"
                        @blur="finishEdit($event,status)"
                      >
                      <span
                        v-if="!status.isEditing"
                        :data-test="'unselected-status-any-' + i"
                        class="boss-any-text"
                      >任意</span>
                      <span
                        v-if="status.isDeletable && !status.isEditing"
                        :data-test="'unselected-status-reset-' + i"
                        class="boss-icon-trash"
                        @click="removeStatus(status)"
                      />
                      <span
                        v-if="status.isDeletable && !status.isEditing"
                        :data-test="'unselected-status-edit-' + i"
                        class="boss-icon-pencil"
                        @click="goEdit(status,`unselected-status-${i}`)"
                      />
                      <validation-label
                        v-if="status.isInvalidName"
                        :data-test="'unselected-status-error-' + i"
                        :label="status.error"
                      />
                    </li>
                  </draggable>
                  <div
                    v-if="isDraggingStatus"
                    class="boss-select-item pega-drop-area border-none-side"
                    data-test="drop-area-status"
                  >
                    <p>↑ この範囲に要素をドラッグしてください</p>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="boss-button-container">
          <button
            data-test="statues-update"
            class="boss-button-default pega-button"
            :disabled="hasEditingStatuses"
            @click="registerStatues"
          >
            選考ステータスを更新する
          </button>
        </div>
      </section>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import draggable from 'vuedraggable'
import SettingHeader from '@/components/atoms/SettingHeader'
import _ from 'lodash'
import ValidationLabel from '@/components/atoms/ValidationLabel'

const dialogPhaseMessage = '<span style="color: #bd4e3f;">このフェーズの応募者はいませんか？</span><br><br>既に利用している選考フェーズを削除する場合、それを設定している応募者の選考フェーズがリセットされます。削除してよろしいですか？'
const dialogStatusMessage = '<span style="color: #bd4e3f;">このステータスの応募者はいませんか？</span><br><br>既に利用している選考ステータスを削除する場合、それを設定している応募者の選考ステータスがリセットされます。削除してよろしいですか？'

export default {
  components: {
    draggable,
    SettingHeader,
    ValidationLabel
  },
  data () {
    return {
      selectedPhases: [],
      unselectedPhases: [],
      selectedStatuses: [],
      unselectedStatuses: [],
      addPhaseName: '',
      addStatusName: '',
      isDraggingPhase: false,
      isDraggingPhaseRequired: false,
      isDraggingStatus: false
    }
  },
  computed: {
    isOverPhaseNameLength () {
      return this.addPhaseName.length > 5
    },
    isOverStatusNameLength () {
      return this.addStatusName.length > 5
    },
    entryPhase () {
      return _(this.selectedPhases).find(phase => phase.isEntryPhase)
    },
    requiredStatuses () {
      return _(this.selectedStatuses).filter('isRequired').value()
    },
    hasEditingPhases () {
      return _.find(this.selectedPhases, p => p.isEditing) !== undefined ||
      _.find(this.unselectedPhases, p => p.isEditing) !== undefined
    },
    hasEditingStatuses () {
      return _.find(this.selectedStatuses, p => p.isEditing) !== undefined ||
      _.find(this.unselectedStatuses, p => p.isEditing) !== undefined
    }
  },
  created () {
    this.fetchSettingPhases()
    this.fetchSettingStatues()
  },
  methods: {
    move (evt) {
      if (_.get(evt, 'draggedContext.element.isRequired') &&
      _.get(evt, 'to.id') === 'unselected') {
        return false
      }
    },
    addPhase (e) {
      if (e.key === 'Enter') {
        if (this.isOverPhaseNameLength) {
          e.preventDefault()
          return false
        }
        if (this.addPhaseName.length > 0) {
          this.$set(this, 'unselectedPhases', [{ id: null, name: this.addPhaseName, isRequired: false, isDeletable: true }].concat(this.unselectedPhases))
        }
        this.$set(this, 'addPhaseName', '')
        e.preventDefault()
        return false
      }
    },
    removePhase (phase) {
      this.unselectedPhases = this.unselectedPhases.filter(p => p !== phase)
    },
    goEdit (val, refsPath) {
      this.$set(val, 'editName', val.name)
      this.$set(val, 'isEditing', true)
      // 編集ボタンを押下した時にinputにフォーカスが当たるようにする
      this.$nextTick(() => { _.head(this.$refs[refsPath]).focus() })
    },
    finishEdit (e, val) {
      if ((e.key === 'Enter' || e.type === 'blur') && _.get(val, 'isEditing', true)) {
        this.checkInvalidName(val)
        if (_.get(val, 'isInvalidName', false)) return

        this.$set(val, 'name', val.editName)
        this.$set(val, 'editName', '')
        this.$set(val, 'isEditing', false)
      }
    },
    changePhase (evt) {
      _.has(evt, 'removed') &&
      this.dialogConfirm(dialogPhaseMessage, () => {}, () => {
        _.remove(this.unselectedPhases, (phase) => { return phase === _.get(evt, 'removed.element') })
        this.selectedPhases.splice(_.get(evt, 'removed.oldIndex'), 0, _.get(evt, 'removed.element'))
      })
    },
    addStatus (e) {
      if (e.key === 'Enter') {
        if (this.isOverStatusNameLength) {
          e.preventDefault()
          return false
        }
        if (this.addStatusName.length > 0) {
          this.unselectedStatuses = [{ id: null, name: this.addStatusName, isRequired: false, isDeletable: true }].concat(this.unselectedStatuses)
        }
        this.$set(this, 'addStatusName', '')
        e.preventDefault()
        return false
      }
    },
    removeStatus (status) {
      this.unselectedStatuses = this.unselectedStatuses.filter(p => p !== status)
    },
    changeStatus (evt) {
      _.has(evt, 'removed') &&
      this.dialogConfirm(dialogStatusMessage, () => {}, () => {
        _.remove(this.unselectedStatuses, (status) => { return status === _.get(evt, 'removed.element') })
        this.selectedStatuses.splice(_.get(evt, 'removed.oldIndex'), 0, _.get(evt, 'removed.element'))
      })
    },
    dialogConfirm (message, callback = () => {}, cancel = () => {}) {
      this.$dialog.confirm(message)
        .then(callback)
        .catch(cancel)
    },
    fetchSettingPhases () {
      return this.$http.secured.get('/admin/settings/entry/phases').then(response => {
        this.$set(this, 'selectedPhases', response.data.selectedPhases)
        this.$set(this, 'unselectedPhases', response.data.unselectedPhases)
      })
    },
    registerPhases () {
      this.$http.secured.put('/admin/settings/entry/phases', {
        selectedPhases: this.selectedPhases,
        unselectedPhases: this.unselectedPhases
      }).then(response => {
        this.$set(this, 'selectedPhases', response.data.selectedPhases)
        this.$set(this, 'unselectedPhases', response.data.unselectedPhases)
        this.$toasted.global.success({ message: '選考フェーズの設定を更新しました。' })
      })
    },
    fetchSettingStatues () {
      return this.$http.secured.get('/admin/settings/entry/statuses').then(response => {
        this.$set(this, 'selectedStatuses', response.data.selectedStatuses)
        this.$set(this, 'unselectedStatuses', response.data.unselectedStatuses)
      })
    },
    registerStatues () {
      this.$http.secured.put('/admin/settings/entry/statuses', {
        selectedStatuses: this.selectedStatuses,
        unselectedStatuses: this.unselectedStatuses
      }).then(response => {
        this.$set(this, 'selectedStatuses', response.data.selectedStatuses)
        this.$set(this, 'unselectedStatuses', response.data.unselectedStatuses)
        this.$toasted.global.success({ message: '選考ステータスの設定を更新しました。' })
      })
    },
    checkInvalidName (val) {
      const name = val.editName
      if (name === '' || name.length > 5) {
        this.$set(val, 'error', '1文字から5文字で入力してください')
        this.$set(val, 'isInvalidName', true)
      } else {
        this.$set(val, 'error', '')
        this.$set(val, 'isInvalidName', false)
      }
    },
    changeDraggingPhase (evt) {
      this.isDraggingPhase = !this.isDraggingPhase
      if (_.get(evt, 'item._underlying_vm_.isRequired')) {
        this.isDraggingPhaseRequired = !this.isDraggingPhaseRequired
      }
    },
    changeDraggingStatus () {
      this.isDraggingStatus = !this.isDraggingStatus
    }
  }
}
</script>
